// LUMILUX cart drawer upsell: offers the Hair Growth Serum when a comb/brush
// product (TheraBrush or LumiScalp Pro) is in the cart.
document.addEventListener('click', function (event) {
  const button = event.target.closest('.lumilux-cart-upsell__add');
  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.lumiluxUpsellVariantId;
  if (!variantId) return;

  button.disabled = true;
  const originalLabel = button.textContent;
  button.textContent = 'Adding…';

  fetch(`${routes.cart_add_url}`, {
    ...fetchConfig(),
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        console.error('LUMILUX cart upsell: add to cart failed', data);
        button.disabled = false;
        button.textContent = originalLabel;
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lumilux-cart-upsell' });
      } else {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.error('LUMILUX cart upsell: add to cart error', error);
      button.disabled = false;
      button.textContent = originalLabel;
    });
});
